var map = {
	"./Base": 740,
	"./Base/": 740,
	"./Base/index": 740,
	"./Base/index.js": 740,
	"./Base/style": 180,
	"./Base/style.js": 180,
	"./Clutch": 431,
	"./Clutch/": 431,
	"./Clutch/index": 431,
	"./Clutch/index.js": 431,
	"./Clutch/renderComponent": 1651,
	"./Clutch/renderComponent.js": 1651,
	"./Clutch/style": 1303,
	"./Clutch/style.js": 1303,
	"./NewUi": 1023,
	"./NewUi/": 1023,
	"./NewUi/index": 1023,
	"./NewUi/index.js": 1023,
	"./NewUi/style": 1304,
	"./NewUi/style.js": 1304,
	"./OldUi": 1024,
	"./OldUi/": 1024,
	"./OldUi/index": 1024,
	"./OldUi/index.js": 1024,
	"./OldUi/renderComponent": 1652,
	"./OldUi/renderComponent.js": 1652,
	"./OldUi/style": 1305,
	"./OldUi/style.js": 1305,
	"./SpireonNew": 1025,
	"./SpireonNew/": 1025,
	"./SpireonNew/index": 1025,
	"./SpireonNew/index.js": 1025,
	"./SpireonNew/renderComponent": 1653,
	"./SpireonNew/renderComponent.js": 1653,
	"./SpireonNew/style": 1306,
	"./SpireonNew/style.js": 1306,
	"./SpireonOld": 1026,
	"./SpireonOld/": 1026,
	"./SpireonOld/index": 1026,
	"./SpireonOld/index.js": 1026,
	"./SpireonOld/renderComponent": 1654,
	"./SpireonOld/renderComponent.js": 1654,
	"./SpireonOld/style": 1307,
	"./SpireonOld/style.js": 1307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;